<div class="flex flex-wrap justify-end gap-4 filters-wrapper">
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="accessionNumber"
    type="text"
    placeholder="Search by accession no."
    class="border-b-1 text-sm border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
  />
</div>
<div class="mb-4"></div>
<p-table
  [value]="processedDuplicateFilings"
  [paginator]="processedDuplicateFilings.length > 0"
  [first]="first"
  (onLazyLoad)="loadData($event)"
  [lazy]="true"
  [totalRecords]="paginator.totalCount"
  [rows]="paginator.pageSize"
  [loading]="isLoading"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem' }"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  (onPage)="pageChange($event)"
  [(selection)]="selectedAggregateShares"
  dataKey="entryId"
  [rowsPerPageOptions]="[10, 25, 50]"
  (onRowSelect)="viewFilingsModal($event.data)"
  selectionMode="single"
>

  <ng-template #header>
    <tr>
      <th>Accession Number</th>
      <th>Filing Date</th>
      <th>Filing Type</th>
    </tr>
  </ng-template>
  <ng-template #body let-share>
    <tr [pSelectableRow]="share">
<!--      <td>-->
<!--        <a-->
<!--          *ngIf="share.filingId; else empty"-->
<!--          [href]="-->
<!--            '/inbox?filingId=' +-->
<!--            share.filingId +-->
<!--            '&filingState=' +-->
<!--            share.filingState-->
<!--          "-->
<!--          [style.color]="'#4a90e2'"-->
<!--          [style.cursor]="'pointer'"-->
<!--          [style.text-decoration]="'underline'"-->
<!--          rel="noopener"-->
<!--          target="_blank"-->
<!--          >{{ share.filingId }}</a-->
<!--        >-->

<!--        <ng-template #empty>-->
<!--          <span>-</span>-->
<!--        </ng-template>-->
<!--      </td>-->
      <td>{{ share.accessionNumber || "N/A" }}</td>
      <td>{{ share.filingDate || "N/A" }}</td>
      <td>{{ share.filingType || "N/A" }}</td>
    </tr>
  </ng-template>
</p-table>

<ng-container *ngIf="!isLoading && processedDuplicateFilings.length === 0">
  <div class="text-center py-6 text-gray-500">No record found</div>
</ng-container>
